import { OnChangeParams } from 'baseui/select';
import { supportedEmbeddingAttributeTypes } from '@tigergraph/tools-models';
import { AttributeSelect } from '@/components/schemaDesigner/attributeEditorContainer/attributeEditor/AttributeSelect';

export interface EmbeddingAttributeDataTypeSelectProps {
  dataType: string;
  readOnly?: boolean;
  onChange: (dataType: string) => void;
}

export default function EmbeddingAttributeDataTypeSelect({
  dataType,
  readOnly,
  onChange,
}: EmbeddingAttributeDataTypeSelectProps) {
  const options = supportedEmbeddingAttributeTypes.map((type) => ({ id: type, label: type }));

  const handleChange = ({ value }: OnChangeParams) => {
    if (value.length > 0) {
      const newDataType = value[0].id as string;
      onChange(newDataType);
    }
  };

  return (
    <AttributeSelect
      disabled={readOnly}
      options={options}
      value={[{ id: dataType, label: dataType }]}
      onChange={handleChange}
      placeholder="Select data type"
    />
  );
}
